import { Container } from "@mui/material";
import { useParams } from "react-router-dom";
import HeaderBreadcrumbs from "~src/components/HeaderBreadcrumbs";
import Page from "~src/components/Page";
import useSettings from "~src/hooks/useSettings";
import { PATH_SEARCH } from "~src/routes/paths";
import { SearchResultsList } from "~src/sections/search/SearchResultsList";

export default function Search() {
  const { themeStretch } = useSettings();
  const params: { searchTerm?: string } = useParams();

  return (
    <Page title="Search Results">
      <Container maxWidth={themeStretch ? false : "xl"}>
        <HeaderBreadcrumbs
          heading={`Search results for: "${params.searchTerm}"`}
          homeIcon="search"
          links={[
            {
              name: "Search Results",
              href: PATH_SEARCH.result(params.searchTerm || ""),
            },
          ]}
        />
        <SearchResultsList searchTerm={params.searchTerm || ""} />
      </Container>
    </Page>
  );
}
